import React from "react";
import PropTypes from "prop-types";

const shapes = {
  round: "rounded-[30px]",
};
const variants = {
  fill: {
    indigo_300: "bg-indigo-300 shadow-xs text-white-A700",
  },
};
const sizes = {
  xs: "h-[42px] px-7 text-2xl",
};

const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape,
  variant = "fill",
  size = "xs",
  color = "indigo_300",
  ...restProps
}) => {
  return (
    <button
      className={`${className}  flex flex-row items-center justify-center text-center cursor-pointer text-white-A700 text-2xl font-medium bg-indigo-300 shadow-xs rounded-[30px] ${(shape && shapes[shape]) || ""} ${(size && sizes[size]) || ""} ${(variant && variants[variant]?.[color]) || ""}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  shape: PropTypes.oneOf(["round"]),
  size: PropTypes.oneOf(["xs"]),
  variant: PropTypes.oneOf(["fill"]),
  color: PropTypes.oneOf(["indigo_300"]),
};

export { Button };

// import React from "react";
// import PropTypes from "prop-types";

// const shapes = {
//   round: "rounded-[30px]",
// };

// const variants = {
//   fill: {
//     indigo_300: "bg-indigo-300 shadow-xs text-white",
//   },
// };

// const sizes = {
//   // Your requested "WEB" size
//   sm: "h-[2.4em] px-[20px] py-[10px] text-[14px]",
//   // Your original size
//   xs: "h-[42px] px-7 text-2xl",
// };

// const Button = ({
//   children,
//   className = "",
//   leftIcon,
//   rightIcon,
//   shape = "round",
//   variant = "fill",
//   size = "sm", // Changed default to 'sm' for Web
//   color = "indigo_300",
//   ...restProps
// }) => {
//   return (
//     <button
//       className={`
//         ${className} 
//         flex flex-row items-center justify-center text-center cursor-pointer font-medium transition-all duration-200 active:scale-95
//         ${shapes[shape] || ""} 
//         ${sizes[size] || ""} 
//         ${variants[variant]?.[color] || ""}
//       `}
//       {...restProps}
//     >
//       {!!leftIcon && <span className="mr-2">{leftIcon}</span>}
//       {children}
//       {!!rightIcon && <span className="ml-2">{rightIcon}</span>}
//     </button>
//   );
// };

// Button.propTypes = {
//   className: PropTypes.string,
//   children: PropTypes.node,
//   leftIcon: PropTypes.node,
//   rightIcon: PropTypes.node,
//   shape: PropTypes.oneOf(["round"]),
//   size: PropTypes.oneOf(["xs", "sm"]),
//   variant: PropTypes.oneOf(["fill"]),
//   color: PropTypes.oneOf(["indigo_300"]),
// };

// export { Button };